import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, Row, Col } from "react-bootstrap";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import { FaCalendarAlt, FaClipboardList } from "react-icons/fa";

const EmployeeLeavesLanding = () => {
  const navigate = useNavigate();

  const leaveLinks = [
    {
      name: "Leave Application",
      path: "/leave",
      icon: <FaCalendarAlt size={22} className="text-dark" />,
    },
    {
      name: "My Leaves",
      path: "/allleaves",
      icon: <FaClipboardList size={22} className="text-dark" />,
    },
  ];

  // 🔐 Authentication check
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      toast.error("You must be logged in to access this page.");
      navigate("/");
    }
  }, [navigate]);

  // ✅ Load Bootstrap dynamically
  useEffect(() => {
    const bootstrapLink = document.createElement("link");
    bootstrapLink.rel = "stylesheet";
    bootstrapLink.href =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
    document.head.appendChild(bootstrapLink);

    const iconsLink = document.createElement("link");
    iconsLink.rel = "stylesheet";
    iconsLink.href =
      "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
    document.head.appendChild(iconsLink);

    return () => {
      bootstrapLink.remove();
      iconsLink.remove();
    };
  }, []);

  return (
    <>
      {/* 🔹 Fixed Navbar */}
      <div className="fixed-top">
        <EmployeeNavbar />
      </div>

      {/* 🔹 Full-Width Page */}
      <div
        className="leaves-page"
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(135deg, #eef1f7 0%, #ffffff 100%)",
          paddingTop: "140px",
          paddingBottom: "60px",
        }}
      >
        <div className="container-fluid px-5">
          <Row className="align-items-center g-5">
            {/* 🟢 LEFT COLUMN - Info Section */}
            <Col
              xs={12}
              md={5}
              className="d-flex flex-column justify-content-center text-center text-md-start"
            >
              <h1 className="fw-bold mb-3 text-dark">Leave Overview</h1>
              <p
                className="text-secondary fs-5"
                style={{
                  textAlign: "justify",
                  lineHeight: "1.7",
                  maxWidth: "600px",
                }}
              >
                Manage your leaves easily and efficiently. The Leave module
                allows you to apply for time off, check your leave history, and
                monitor approval status — all from one convenient dashboard.
                Stay organized and keep your work-life balance in check.
              </p>
            </Col>

            {/* 🔵 RIGHT COLUMN - Cards Grid */}
            <Col xs={12} md={7}>
              <Row xs={2} sm={3} md={3} lg={4} className="g-3">
                {leaveLinks.map((item, idx) => (
                  <Col key={idx}>
                    <Link
                      to={item.path}
                      className="text-decoration-none text-dark"
                    >
                      <Card className="shadow-sm h-100 border-0 hover-card text-center py-3 px-2">
                        <div className="mb-2">{item.icon}</div>
                        <h6 className="fw-semibold mb-0">{item.name}</h6>
                      </Card>
                    </Link>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </div>

        {/* 🎨 Hover + Card Styles */}
        <style>
          {`
          .hover-card {
            background: #fff;
            border-radius: 12px;
            transition: all 0.25s ease;
          }
          .hover-card:hover {
            transform: translateY(-4px) scale(1.03);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }
          h6 {
            font-size: 0.95rem;
          }
        `}
        </style>
      </div>
    </>
  );
};

export default EmployeeLeavesLanding;
